var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center"},[_c('div',{},[_c('em',[_vm._v("Todos los derechos reservados "+_vm._s(new Date().getFullYear()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }